import React from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Modal from 'components/Modal';
import {Button, Col, Row} from "react-bootstrap";
import FormInput from "../../forms/FormInput";
import DateTimePicker from "../../forms/DateTimePicker";
import moment from "moment";
import {connect} from "react-redux";
import {getTimezoneFromState} from "../../../helpers/intl";
import _ from "lodash";
import FormLangRichEditor from "../../forms/FormLangRichEditor";
import {editUpdateNotificationR} from "actions/ListActions";

class UpdateEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: "",
      dateTimeFrom: moment(Date.now()),
      dateTimeTo: moment(Date.now()),
      updateName: "",
      updateDescription: "",
    };
  }

  componentDidMount = (prevProps) => {
  }

  componentDidUpdate = (prevProps) => {
    if(prevProps.id !== this.props.id || prevProps.show !== this.props.show && this.props.show === true){
      const { list } = this.props;
      const index = _.findIndex(list, _list => _list.id === this.props.id);
      if(index !== -1) {
        this.setState({
          id: list[index].id,
          updateName: list[index].name,
          updateDescription: list[index].description,
          dateTimeFrom: list[index].date_from,
          dateTimeTo: list[index].date_to,
        })
      }
    }

  }

  changeDateTimeFrom = (name, value) => {
    this.setState({
      dateTimeFrom: value,
    })
  }

  changeDateTimeTo = (name, value) => {
    this.setState({
      dateTimeTo: value,
    })
  }

  changeUpdateName = (value) => {
    this.setState({
      updateName: value,
    })
  }


  changeUpdateDescription = (name, value) => {
    this.setState({updateDescription:value});
  }

  editUpdateNotification = () => {
    const { dateTimeFrom, dateTimeTo, updateName, updateDescription, id} = this.state;
    let data = {id: id, name: updateName, description: updateDescription, date_from: dateTimeFrom, date_to: dateTimeTo };
    this.props.editUpdateNotificationR(data);
    this.props.close();
  }




  render() {
    const { intl, show, close,  appIntl, defaultTimezone } = this.props;
    const { dateTimeFrom, dateTimeTo, updateName, updateDescription, id} = this.state;
    const messages = intl.messages;
    let editDisabled = true;
    if(updateName !== null && dateTimeFrom !== null && dateTimeTo !== null && updateDescription !== null){
      editDisabled = false;
    }
    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.edit_update_notification}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12}>
              <div>
                <h4></h4>
              </div>
              <div className="form-group form-group-default p-t-10 p-b-10 addSubscriptionForm" >
                <FormInput
                  type="text"
                  label={messages.update_name}
                  name="name"
                  onChange={(name, value) => {this.changeUpdateName(value)}}
                  value={updateName}
                />
                <FormLangRichEditor
                  name="description"
                  label={messages.update_notification_description}
                  value={this.state.updateDescription}
                  onChange={(name, value) => {this.changeUpdateDescription(name, value)}}
                />
                <DateTimePicker
                  value={dateTimeFrom}
                  label={messages.update_from}
                  locale={appIntl.locale}
                  displayTz={defaultTimezone}
                  onChange={this.changeDateTimeFrom}
                />
                <DateTimePicker
                  value={dateTimeTo}
                  label={messages.update_to}
                  locale={appIntl.locale}
                  displayTz={defaultTimezone}
                  onChange={this.changeDateTimeTo}
                />
                <Button onClick={()=>this.editUpdateNotification()} disabled={editDisabled} bsStyle="primary"  className="pull-right" title="create_subscription">
                  <span className="hidden-xs">{messages.save}</span>
                </Button>
              </div>
            </Col>
          </Row>

        </Modal.Body>
      </Modal>
    );
  }
}


const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    pending: state.list.updates.pendingUp,
    list: state.list.updates.data.list,
    defaultTimezone: getTimezoneFromState(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    editUpdateNotificationR: (data) => {
      dispatch(editUpdateNotificationR(data));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(UpdateEdit)
  )
);

